import { FieldValues, UseFormSetValue, UseFormWatch } from "react-hook-form";
import { TypeMapping } from "../../types/api/Feed";
import { getValidTypes } from "../../utils/postTypes";

export function PostType({
  name,
  setValue,
  watch,
  postTypes,
  typeMapping,
}: {
  name: string;
  setValue: UseFormSetValue<FieldValues>;
  watch: UseFormWatch<FieldValues>;
  postTypes: string[];
  typeMapping?: TypeMapping;
}) {
  const formKey = `${name}.type`;

  const onSelect = (type: string) => {
    setValue(formKey, type);
  };

  const validTypes = getValidTypes(postTypes, typeMapping);

  if (validTypes.length === 1) {
    return null;
  }

  return (
    <div>
      <label className="select">
        <span className="label">Type</span>
        <select onChange={(e) => onSelect(e.target.value)}>
          <option>Personal</option>

          {validTypes?.map((t) => (
            <option value={t.type} key={t.type}>
              {t.name}
            </option>
          ))}
        </select>
      </label>

      <div className="flex justify-start gap-2"></div>
    </div>
  );
}
